import React from 'react';
import { Typography } from '@mui/material';

const SectionHeading = ({ children, sx, ...props }) => (
  <Typography
    variant="h6"
    gutterBottom
    {...props}
    sx={{
      fontFamily: "'Sofia Pro Bold', 'Sofia Pro', sans-serif",
      fontWeight: 700,
      fontSize: '18px',
      color: '#475969',
      mb: 3,
      ...sx,
    }}
  >
    {children}
  </Typography>
);

export default SectionHeading;
